import { Directive, ViewContainerRef } from '@angular/core';

/**
 * It is an anchor element that specifies the location of this container in the containing view. 
 */

@Directive({
    selector: '[appContainerRef]',
    standalone: false
})
export class ContainerRefDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
